export default __webpack_public_path__ + "static/media/hex-active.9beed671.svg";